import 'Styles/templates/collection.mixmatch-products.scss';

import CollectionMixmatch from '../vue/collection-mixmatch/index';

CollectionMixmatch();